export enum NetworkErrorMessage {
  NetworkError = 'network error',
  ConnectionRefused = 'connection refused',
  FetchFailed = 'fetch failed',
  FailedToFetch = 'failed to fetch',
  ConnectionReset = 'connection reset',
  Timeout = 'timeout',
}
